export default "__VITE_ASSET__BUX79Hna__"